<template>
  <div class="ppdai-network-problem"
       @click="onReload"
       @touchmove.prevent>
    <img class="without-network"
         src="@/assets/img/common/pic_no_net.png" />
    <div class="desc">网络异常，请检查网络设置</div>
    <div class="button">轻触屏幕重新加载</div>
  </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {};
    },
    methods: {
        onReload() {
            location.reload();
        }
    }
};
</script>

<style lang="less" scoped>
@import '../../../assets/less/mixins.less';
.ppdai-network-problem {
  z-index: 999;
  .setPosition(fixed, 0, 0, 0, 0);
  .setFlexPos(column, flex-start, center);
  background: #fff;
  .without-network {
    margin-top: 160px;
    .setSize(240px, 140px);
  }
  .desc {
    font-size: 16px;
    color: #384369;
    margin-top: 20px;
  }
  .button {
    font-size: 14px;
    color: #7585be;
    margin-top: 40px;
  }
}
</style>
